import Vue from 'vue';
import '@/utils/jumper2router.js';
import lodash from 'lodash';
import store from '@/store';
// 数字转2位小数金额
import {
  number2money,
  getFileTypeByUrl,
  disabledPickerDate,
  pickerOptions,
  pickerOption,
  infinityNumber,
  scrollToFormError,
  treeRowStyleFun,
  repeatArrayFun,
  isSameArrayStringify,
  messageBox,
} from '@/utils/index.js';
import operateLogs from '@/utils/log.js';
import * as api from '@/api';
import { MAX_LENGTH } from '@/utils/constants';

Vue.prototype.$lodash = lodash;
//  全局组件之间通信
Vue.prototype.$eventHub = Vue.prototype.$eventHub || new Vue(); // 巴士

Vue.prototype.$rowStyle = {
  DEFAULT: { fontSize: '13px' }, // background: '#eef1f6', color: '#606266',
  LIGHT_GREY: { background: '#f7f7f7', color: '#606266' },
  LIGHT_BLUE: { background: '#c4d9f5', color: '#606266' },
  WHITE: { background: '#FFFFFF', color: '#6c6c6c' },
};

Vue.prototype.$number2money = number2money;
Vue.prototype.$getFileTypeByUrl = getFileTypeByUrl;
Vue.prototype.$disabledPickerDate = disabledPickerDate;
Vue.prototype.$pickerOptions = pickerOptions;
Vue.prototype.$pickerOption = pickerOption;
Vue.prototype.$infinityNumber = infinityNumber;
Vue.prototype.$scrollToFormError = scrollToFormError;
Vue.prototype.$treeRowStyleFun = treeRowStyleFun;
Vue.prototype.$repeatArrayFun = repeatArrayFun;
Vue.prototype.$isSameArrayStringify = isSameArrayStringify;
Vue.prototype.$MessageBox = messageBox;

Vue.prototype.$isSiteRole = (flag = true) => {
  return store.getters.isSiteRole == flag;
};
Vue.prototype.$isEmptyTenantId = id => {
  if (id || id === 0 || id === '0') {
    return false;
  }
  return true;
};
Vue.prototype.$filterCols = (dropCols = []) => {
  return dropCols.filter(e => {
    if (store.getters.isSiteRole) {
      // 平台级 // 不显示以OnlyTenant结尾的prop
      return !e.prop.endsWith('OnlyTenant');
    } else {
      // 租户级 // 不显示租户 / 不显示以OnlySite结尾的prop
      return e.prop !== 'tenantName' && !e.prop.endsWith('OnlySite');
    }
  });
};

import * as BjDialogListConfig from '@/utils/BjDialogListConfig.js';
Vue.prototype.$BjDialogListConfig = BjDialogListConfig;

Vue.prototype.msgSuccess = function(msg) {
  this.$message({ showClose: true, message: msg, type: 'success' });
};
Vue.prototype.msgError = function(msg) {
  this.$message({ showClose: true, message: msg, type: 'error' });
};
Vue.prototype.msgInfo = function(msg) {
  this.message.info(msg);
};
// 操作日志
Vue.prototype.$operateLogs = (obj = {}, type = 'commonDefault') => {
  if (!lodash.isString(obj.api)) throw new Error('KEY api 类型不正确');
  obj.actionApi = api[obj.api].getLogPage;
  operateLogs(BjDialogListConfig[type](obj.title, obj));
};
Vue.prototype.MAX_LENGTH = MAX_LENGTH;

Vue.prototype.$getPublicImage = url => {
  return `/image/${url}`;
};

const Mock = require('mockjs');
Vue.prototype.$getMockData = list => {
  const res = Mock.mock({
    'list|6-10': list,
  }).list;
  return res;
};
